import firebase from "firebase";
import "firebase/database";

let config = {
    apiKey: "AIzaSyAWU-f4McbKojqiEMcxm3qHCNwJswgyuM8",
    authDomain: "vermillion-stage.firebaseapp.com",
    databaseURL: "https://vermillion-stage.firebaseio.com",
    projectId: "vermillion-stage",
    storageBucket: "vermillion-stage.appspot.com",
    messagingSenderId: "741959654739",
    appId: "1:741959654739:web:e91b74cf0fbcb7285ed5a6"
};

firebase.initializeApp(config);
const firebaseDb = firebase.database();
const firebaseAuth = firebase.auth();

export {firebaseDb, firebaseAuth};